/**
 * offlineSync.ts
 *
 * Thin adapter che espone `offlineSyncQueue` (size/flush) attorno alla coda
 * persistente `offlineQueue`. Il replay vero e proprio è DELEGATO a
 * `backgroundSync`.
 *
 * FIX OFFLINE-FLUSH (Ott 2026) — la versione precedente reimplementava il
 * replay con una mappa di URL in parte inesistenti (`/api/user/profile`,
 * `/api/user/avatar`) e con `fetch(url)` **relativo**, senza header
 * Authorization: la richiesta non raggiungeva l'API ma l'origine web (o il
 * server locale di Capacitor), con due esiti entrambi gravi:
 *   - 404 → azione marcata failed e mai più riprovata;
 *   - 200 di fallback SPA (host statico) → res.ok=true → azione RIMOSSA dalla
 *     coda pur non essendo mai stata applicata = perdita silenziosa di dati
 *     (eventi creati offline, aggiornamenti profilo, moto aggiunte).
 *
 * Ora esiste UNA sola implementazione del replay (`backgroundSync`), che usa
 * `apiFetch` (base URL + token autenticato) e gestisce retry/backoff.
 */

import { getPendingActions } from './offlineQueue';
import { syncPendingActions } from './backgroundSync';

export const offlineSyncQueue = {
  /** Numero di azioni in coda (pending + syncing + failed). */
  async size(): Promise<number> {
    const actions = await getPendingActions();
    return actions.length;
  },

  /**
   * Riprova tutte le azioni in coda.
   * Le azioni applicate con successo vengono rimosse; quelle fallite
   * incrementano il contatore di retry e diventano `failed` dopo 3 tentativi.
   */
  async flush(): Promise<void> {
    await syncPendingActions();
  },
};
